<template><section><h1>Loadmore</h1>
<blockquote>
<p>加载更多</p>
</blockquote>
<h2>代码示例</h2>
<p>以下示例，模拟异步加载的时间为 1 秒</p>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>done</td>
<td style="text-align:left">是否已经全部加载完毕</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>interval</td>
<td style="text-align:left">手动点击加载出现间隔</td>
<td><code>Number</code></td>
<td><code>3</code></td>
</tr>
<tr>
<td>offset</td>
<td style="text-align:left">距离到容器底部<code>300px</code>时加载</td>
<td><code>Number</code></td>
<td><code>300</code></td>
</tr>
<tr>
<td>real_time</td>
<td style="text-align:left">是否每次滚动都监听容器高度</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
</tbody>
</table>
<table>
<thead>
<tr>
<th>事件</th>
<th style="text-align:left">说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>load-method</td>
<td style="text-align:left">加载时调用方法</td>
<td><code>[next &lt;Function:异步加载完毕后调用&gt;, err: &lt;Function:加载出错时调用&gt;]</code></td>
</tr>
</tbody>
</table>
<table>
<thead>
<tr>
<th>方法</th>
<th style="text-align:left">说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>reset</td>
<td style="text-align:left">重置组件状态</td>
</tr>
</tbody>
</table>
<h2>Slot</h2>
<table>
<thead>
<tr>
<th>名字</th>
<th style="text-align:left">说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>loading</td>
<td style="text-align:left">加载中的内容</td>
</tr>
<tr>
<td>loadmore</td>
<td style="text-align:left">手动加载更多的内容</td>
</tr>
<tr>
<td>error</td>
<td style="text-align:left">出错时的内容</td>
</tr>
</tbody>
</table>
<p><a href="https://vuefe.cn/v2/guide/components.html#%E4%BD%9C%E7%94%A8%E5%9F%9F%E6%8F%92%E6%A7%BD">#</a> 使用 具有特殊属性 <code>scope</code> 的 <code>&lt;template&gt;</code> 元素做插槽时，可在作用域中调用 <code>loadmore</code> 方法去继续加载.</p>
<p>e.g.</p>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"loadmore"</span> <span class="hljs-attr">scope</span>=<span class="hljs-string">"props"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">Btn</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"props.loadmore"</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"blue-btn"</span>&gt;</span>点击加载更多<span class="hljs-tag">&lt;/<span class="hljs-name">Btn</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
</code></pre>
</section></template>

<script>
  import test from '@/pages/demo/Loadmore.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-7.vue?67ce9e4a